import { analyzeXbrl } from "@/apis/dsd/route";
import { DsdFileStatus } from "@/types/dsd";
import queries from "@/queries";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef } from "react";

export function useAnalyzeXbrlOnEntry(workbookId: string | undefined) {
  const { data: dsdList } = useQuery({
    ...queries.dsd(),
    enabled: !!workbookId,
  });
  const triggeredRef = useRef(false);

  useEffect(() => {
    if (!workbookId || !dsdList || triggeredRef.current) return;

    const workbook = dsdList.find((w) => w.id === workbookId);
    if (workbook?.status !== DsdFileStatus.DSD_ANALYZED) return;

    triggeredRef.current = true;
    analyzeXbrl(workbookId).catch(() => {});
  }, [workbookId, dsdList]);
}
